export const headCells = [
  {
    id: "Event_ID",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Event ID",
    width: 100,
  },
  {
    id: "EventDate",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Event Date",
    width: 180,
    showTimezone: true,
  },
  {
    id: "EventType",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Event Type",
    width: 150,
  },
  {
    id: "User",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "User",
    width: 120,
  },
  {
    id: "Workspace",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Workspace",
    width: 120,
  },
  {
    id: "Message",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "Message",
    width: 250,
  },
];

export const actionList = [
  { name: "AUTHENTICATION", value: 1 },
  { name: "AUTHORIZATION", value: 2 },
  { name: "SYSTEM", value: 3 },
  { name: "WORKSPACE", value: 4 },
  { name: "MODEL", value: 5 },
  { name: "JOB", value: 6 },
  { name: "DATA PIPELINE", value: 7 },
  { name: "CUSTOM", value: 99 },
];

export const rowsPerPageOptions = [10, 25, 50, 100];
